import { TDeviceType } from '@cian/ui-kit';

import { trackPinPaginationClick } from './trackPinPaginationClick';
import { setMapOffer } from '../../../../common/actions/setMapOffer/setMapOffer';
import { selectIsDesktopListingVisible } from '../../../../common/selectors/desktopListing';
import { IReduxStore } from '../../../../common/types/redux';
import { getOfferByDirection } from '../../../../common/utils/ymapsModules/BalloonManager/getOfferByDirection';
import { selectActiveFeature, selectActiveOfferId } from '../../../selectors';
import { getPositionInPin } from '../../../utils/getPositionInPin';

export function handlePinPaginationClick(
  direction: 'prev' | 'next',
  deviceType: TDeviceType,
  store: Pick<IReduxStore, 'getState' | 'dispatch'>,
): void {
  // Читаем выбор на каждый клик: быстрые нажатия могут прийти до следующего React-рендера.
  const state = store.getState();
  const feature = selectActiveFeature(state);
  if (!feature) {
    return;
  }

  const { offers } = feature.properties;
  const offer = getOfferByDirection(offers, selectActiveOfferId(state), direction);
  if (!offer) {
    return;
  }

  store.dispatch(setMapOffer({ realtyId: offer.realtyId, feature }));
  trackPinPaginationClick({
    direction,
    realtyId: offer.realtyId,
    position:
      getPositionInPin(
        offers.map(pinOffer => pinOffer.realtyId),
        offer.realtyId,
      ) ?? 1,
    isDesktopListingVisible: selectIsDesktopListingVisible(state),
    deviceType,
  });
}
